import { useNavigation, useRoute } from "@react-navigation/native"
import { useSelector } from "react-redux"
import { useCurrentActivity } from "./useCurrentActivity"

const useLaunchActivity = (nav = null, route = null) => {
    const navigation = nav ?? useNavigation()
    route = route ?? useRoute()
    const liveMode = useSelector((state) => state.liveMode)
    const { setCurrentActivity } = useCurrentActivity()

    const navigateToActivityScreen = (
        activityData,
        navigationType = "push",
        withGoBack = false
    ) => {
        const data = {
            activityData,
            progressStatus: "ongoing",
        }

        setCurrentActivity(data)

        if (route?.name === "congrats" || withGoBack) {
            navigation.goBack()
        }

        //? If we're in liveMode, the student's main menu is the activity screen
        else if (!liveMode?.isLiveModeEnabled && route?.name !== "activity") {
            if (navigationType === "push") {
                navigation.push("activity")
            } else if (navigationType === "replace") {
                navigation.replace("activity")
            }
        }
    }

    return navigateToActivityScreen
}

export default useLaunchActivity
